<div
  *ngIf="(_isLoggedIn$ | async) else notLoggedIn"
  class="app-root-layout"
>
  <cosmos-navbar></cosmos-navbar>
  <div class="app-root-layout__content-wrapper">
    <cosmos-sidebar class="app-root-layout__sidebar"></cosmos-sidebar>

      <div class="app-root-layout__page__content">
        <router-outlet class="app-root-layout__main-content"></router-outlet>
      </div>
  </div>
</div>

<ng-template #notLoggedIn>
  <div class="app-root-layout__login-content">
    <router-outlet></router-outlet>
  </div>
</ng-template>
